import { usePage } from "@inertiajs/inertia-vue3";
import { defineStore } from "pinia";

export const useStore = defineStore("main", {
  state: () => {
    return {
      navIsSmall: false,
      isAdmin: false,
      env: "production",
      wcBaseUrl: "https://www.hcpet.no",
    };
  },
  actions: {
    setUpStore() {
      const page = usePage();

      this.isAdmin = page.props.value.isAdmin as boolean;
      this.env = page.props.value.env as string;
      this.wcBaseUrl = page.props.value.wcBaseUrl as string;
    }
  }
});
